export default function RegistrationSection() {
  const methods = [
    {
      number: '1',
      title: '司法書士などに依頼する',
      description: '専門家に依頼することで、確実かつスムーズに手続きを進めることができます。',
      icon: 'ri-user-star-line',
      color: 'from-teal-500 to-cyan-500'
    },
    {
      number: '2',
      title: 'ご本人による書類作成・申請',
      description: 'ご自身で書類を作成し、法務局に申請することも可能です。',
      icon: 'ri-edit-box-line',
      color: 'from-cyan-500 to-blue-500'
    },
    {
      number: '3',
      title: 'インターネットの書類作成サービスを利用する',
      description: 'オンラインサービスを活用して、効率的に書類を作成できます。',
      icon: 'ri-global-line',
      color: 'from-blue-500 to-indigo-500'
    }
  ];

  return (
    <section className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-flex items-center px-6 py-3 bg-purple-50 rounded-full mb-6">
            <i className="ri-government-line text-purple-600 text-xl mr-3"></i>
            <span className="text-purple-600 text-sm font-bold">REGISTRATION</span>
          </div>
          <h2 className="text-5xl font-black text-gray-900 mb-6">
            変更登記の<span className="bg-gradient-to-r from-teal-500 to-cyan-500 bg-clip-text text-transparent">実施について</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            法人の譲渡時（株式譲渡時）に、同時に変更登記を行っていただきます。<br />
            特に<span className="text-red-600 font-bold">役員の変更、法人所在地の変更は必ず行って頂く</span>必須事項となっております。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {methods.map((method, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 hover:shadow-2xl transition-all duration-500 border border-gray-200 hover:border-purple-300"
            >
              {/* Number Badge */}
              <div className={`absolute -top-4 -right-4 w-12 h-12 bg-gradient-to-br ${method.color} rounded-xl flex items-center justify-center shadow-lg transform group-hover:scale-110 group-hover:rotate-12 transition-all duration-500`}>
                <span className="text-white text-xl font-black">{method.number}</span>
              </div>

              {/* Icon */}
              <div className={`w-16 h-16 bg-gradient-to-br ${method.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-500`}>
                <i className={`${method.icon} text-3xl text-white`}></i>
              </div>

              {/* Content */}
              <h3 className="text-xl font-black text-gray-900 mb-4 leading-tight">
                {method.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm">
                {method.description}
              </p>
            </div>
          ))}
        </div>

        {/* Help Section */}
        <div className="bg-gradient-to-br from-purple-50 to-indigo-50 rounded-3xl p-10 border border-purple-200">
          <div className="flex items-center justify-center">
            <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-indigo-500 rounded-xl flex items-center justify-center mr-6 flex-shrink-0">
              <i className="ri-customer-service-2-line text-2xl text-white"></i>
            </div>
            <div>
              <p className="text-xl text-gray-700 leading-relaxed">
                ご不明点はご説明いたしますので、<span className="font-bold text-purple-600">ご相談ください</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
